<template>
  <div>
    <b-row class="margin-top-10">
      <b-col cols="12">
        <p><b-link :to="{ name: 'jobHome', params: { uuid: uuid } }"><strong>{{title}}</strong></b-link></p>
        {{description}}
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: 'job-result',
  props: ['title', 'description', 'url', 'uuid'],
  components: {
  },
  data: () => {
    return {
    }
  },

  mounted () {
  },

  updated () {
  },

  methods: {
  },

  computed: {
  },

  watch: {
  }
}
</script>
<style>
.margin-top-10 {
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/app/employer/components/JobResult.vue